import { useMutation } from '@tanstack/react-query'

import { Logger } from '@core/logger'
import { queryClient } from '@core/query'
import { LikeQueryKey } from '../helpers/queryKeys'

import { unlikeAudio } from '../services/unlikeAudio'
import { isLikeStateAlreadySet } from '../helpers/isLikeStateAlreadySet'
import {
    applyLikedAudioId,
    restoreLikedAudioIds,
    snapshotLikedAudioIds,
    type TLikedSnapshot,
} from '../helpers/likeOptimistic'

export const useUnlikeAudio = () => {
    return useMutation<unknown, Error, string, TLikedSnapshot>({
        mutationFn: audioId => unlikeAudio(audioId),
        onMutate: async audioId => {
            await queryClient.cancelQueries({ queryKey: LikeQueryKey.likedAudioIds() })

            const snapshot = snapshotLikedAudioIds()
            applyLikedAudioId(audioId, false)

            return snapshot
        },
        onError: (error, _audioId, snapshot) => {
            if (isLikeStateAlreadySet(error)) {
                queryClient.invalidateQueries({ queryKey: LikeQueryKey.likedAudioIds() })

                return
            }

            Logger.error('Unlike audio error', { error })
            restoreLikedAudioIds(snapshot)
        },
    })
}
